export const CATEGORY_ICONS = {
  microphones: `  _____
 /     \\
| () () |
 \\  ^  /
  |||||
`,
  speakers: `  _______
 |       |
 |  [=]  |
 |_______|
  |   |`,
  mixers: `  _______
 |_|_|_|_|
 |       |
 |  MIX  |
 |_______|`,
  amps: ` ________
|[][][][]|
|[][][][]|
|________|`,
  amplifiers: ` ________
|[][][][]|
|[][][][]|
|________|`,
};

export const DEFAULT_CATEGORY_ICON = `  .---.
 /     \\
|  ? ?  |
 \\_____/`;
